import { CoreSectionMessage } from '@featuring-corp/components';
import { useTranslation } from 'react-i18next';
import React from 'react';

import { sectionMessageWrapperClass } from './style.css';

export interface SectionMessagesProps {
	isLoading?: boolean;
	isError?: boolean;
	errorCode?: number;
}

const SectionMessages = ({ isError, errorCode, isLoading }: SectionMessagesProps) => {
	const { t } = useTranslation('commonInfReport');

	const sectionMessagesProps: Record<
		string | number,
		Parameters<typeof CoreSectionMessage>[0]
	> = {
		loading: {
			status: 'info',
			title: t('features.report.section-messages.loading.title'),
			description: t('features.report.section-messages.loading.description'),
		},
		400: {
			status: 'info',
			title: t('features.report.section-messages.400.title'),
			description: t('features.report.section-messages.400.description'),
		},
		403: {
			status: 'info',
			title: t('features.report.section-messages.403.title'),
			description: t('features.report.section-messages.403.description'),
		},
		404: {
			status: 'info',
			title: t('features.report.section-messages.404.title'),
			description: t('features.report.section-messages.404.description'),
		},
		406: {
			status: 'info',
			title: t('features.report.section-messages.406.title'),
			description: t('features.report.section-messages.406.description'),
		},
		410: {
			status: 'info',
			title: t('features.report.section-messages.410.title'),
			description: t('features.report.section-messages.410.description'),
		},
	};

	const errorCodes = [400, 403, 404, 406, 410];

	if (isLoading)
		return (
			<div className={sectionMessageWrapperClass}>
				<CoreSectionMessage {...sectionMessagesProps['loading']} />
			</div>
		);

	if (!isLoading && isError)
		return (
			<div className={sectionMessageWrapperClass}>
				<CoreSectionMessage
					{...sectionMessagesProps[
						errorCode && errorCodes.includes(errorCode) ? errorCode : 404
					]}
				/>
			</div>
		);
	else return <></>;
};

export default SectionMessages;
